/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */

import { Routes, Route } from 'react-router-dom';
import { Form } from 'antd';
import useConnectionContext from '@hooks/useConnectionContext';
import { useState, useEffect, useCallback } from 'react';
import { getNextWeekday } from '@/utils';
import request from '@api';
import ApplicationLayout from '../Layout';
import Intro from './Intro';
import EligibleProducts from './EligibleProducts';
import WidgetStatus from './WidgetStatus';
import LiveDate from './LiveDate';
import Review from './Review';
import Feedback from './Feedback';

// const MOCK_OPTIONS = [{
//   value: 10001,
//   label: 'ADIDAS',
// }, {
//   value: 10002,
//   label: 'DSAZF',
// }, {
//   value: 10003,
//   label: 'ERDGGDF',
// }, {
//   value: 10004,
//   label: 'ERDGGDF',
// }, {
//   value: 10005,
//   label: 'ERDGGDF',
// }, {
//   value: 10006,
//   label: 'ERDGGDF',
// }, {
//   value: 10007,
//   label: 'ERDGGDF',
// }, {
//   value: 10008,
//   label: 'ERDGGDF',
// }];

export default function RAApplication() {
  const [form] = Form.useForm();
  const [options, setOptions] = useState([]);
  const { merchantId, store = {} } = useConnectionContext();
  const { name } = store;

  const fetchData = useCallback(async () => {
    try {
      const { code, data: { raOnboardingOptions: { collections = [] } = {} } } = await request('query-onboarding-options', {
        method: 'POST',
        body: {
          merchantId,
          insuranceProductType: 'RA',
        },
      });
      if (code === 0) {
        // setOptions(MOCK_OPTIONS);
        setOptions(collections.map((item) => ({ ...item, value: item.id, label: item.title })));
      }
    } catch (e) {
      console.log(e);
    }
  }, [merchantId]);

  useEffect(() => {
    if (merchantId) {
      fetchData();
    }
  }, [merchantId]);

  return (
    <ApplicationLayout type="ra">
      <Form
        name="enable_ra"
        layout="vertical"
        form={form}
        initialValues={{
          eligible_products: '1',
          widget_status: '1',
          match_type: '1',
          names: [{ condition_type: '1' }],
          date: getNextWeekday(),
        }}
      >

        <Routes>
          <Route path="/intro" element={<Intro />} />
          <Route path="/eligible-products" element={<EligibleProducts options={options} />} />
          <Route path="/widget-status" element={<WidgetStatus />} />
          <Route path="/date" element={<LiveDate />} />
          <Route path="/review" element={<Review options={options} merchantId={merchantId} platform={name} />} />
          <Route path="/feedback" element={<Feedback />} />
        </Routes>
      </Form>
    </ApplicationLayout>

  );
}
